<template>
    <div class="help-center-content">
        <h4>版权管理</h4>
        <p class="title">1.  如何上传我的作品？</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_4.jpeg`"  style="width: 649px;border: 1px solid #eee;">
        <p class="content">入驻成功后，你可进入版权工作台，点击【上传版权内容】按钮，开始提交你的作品 。</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_5.png`"  style="width: 666px;border: 1px solid #eee;">
        <p class="content">你需要填写作品的相关信息，包括书籍名称、ISBN号、出版社、简介等，并上传书籍封面和内容文本。<br>
            除此之外，你还需要填写授权信息，并提供相应作品版权证明和授权文件。</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_9.jpeg`"  style="width: 800px;border: 1px solid #eee;">
        <p class="content">如果你是作家，你需要下载个人授权书模板，签署后上传。<br>
            如果你代表出版机构，除了版权机构授权书外，你还需要提供版权追溯文件</p>
        <p class="title" id="isSolo">2.  独家 / 非独家授权有什么区别？</p>
        <p class="content">
            <strong>独家授权：</strong><br>
            与喜马拉雅建立独家合作，喜马拉雅会给合作的出版机构、作者、主播更多的展示机会，更细致的服务，和更多的潜在收益。 <br>
            <strong>非独家授权：</strong><br>
            您的作品会在喜马拉雅按照普通的付费专辑进行售卖，在资源允许的时候，会给您给予一定程度的推广服务。<br>
        </p>
        <p class="title" id="fee">3.  版权方是否承担费用有什么区别？</p>
        <p class="content">
            版权方是否承担费用，意味着不同的制作流程和收益分配方式（参见表格）。<br>
        </p>
        <table class="copyright">
            <tr><th>事项</th><th>平台承担费用</th><th>版权方承担费用</th></tr>
            <tr><td>上传版权作品</td><td>版权方</td><td>版权方</td></tr>
            <tr><td>发布海选任务招募主播</td><td>平台</td><td>版权方</td></tr>
            <tr><td>挑选主播</td><td>平台</td><td>版权方</td></tr>
            <tr><td>跟进有声作品录制</td><td>平台</td><td>版权方</td></tr>
            <tr><td>分发录制音频至喜马拉雅平台</td><td>平台</td><td>平台</td></tr>
            <tr><td>承担主播录制费用</td><td>平台</td><td>版权方</td></tr>
            <tr><td>获取收益比例</td><td>30%</td><td>50%</td></tr>
        </table>
        <p class="content">
            * 净收益为通过您发布的付费型音频专辑获得的总收入（用户付费收入以及广告收入）扣除成本（包括但不限于渠道成本、支付成本、促销成本等费用）。
        </p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// HelpCenterCopyrightManagement.vue?260945f1